import { Box, Modal, Text } from 'dash-ui';
import { useNavigate } from 'react-router-dom';
import { useTheme } from 'styled-components';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useNavigationBlocker } from 'common/hooks/useNavigationBlocker/useNavigationBlocker';

const ChangesConfirmationModal = ({ condition }: { condition: boolean }) => {
  const { t } = useTranslation('pages');
  const theme = useTheme();
  const navigate = useNavigate();
  const [confirmed, setConfirmed] = useState(false);

  const { isOpenedModal, setIsOpenedModal, pathname, setPathname } =
    useNavigationBlocker(!condition, confirmed);

  // FIXME: re-check next line
  useEffect(() => {
    if (confirmed) {
      navigate(pathname);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [confirmed]);

  const onClose = () => {
    setIsOpenedModal(false);
    setPathname('');
  };

  const submitButtonClick = () => {
    setConfirmed(true);
    setIsOpenedModal(false);
  };

  return (
    <Modal
      isOpen={isOpenedModal}
      title={t('propertyPage.confirmChangesModalTitle') || ''}
      onRequestClose={onClose}
      submitButton={{
        title: t('propertyPage.leavePage'),
        onClick: submitButtonClick,
      }}
      cancelButton={{ title: t('propertyPage.goBack'), onClick: onClose }}
    >
      <Box my={6}>
        <Text color={theme.colors.n80}>
          {t('propertyPage.confirmChangesModalText')}
        </Text>
      </Box>
    </Modal>
  );
};

export default ChangesConfirmationModal;
